import { Pagination } from '@scribe-sas/types/admin'
import autoBind from 'auto-bind'
import engine from 'engine'
import SignatureTemplateModel from 'engine/signatureTemplates/SignatureTemplateModel'
import { debounce, kebabCase } from 'lodash'
import { makeAutoObservable, reaction } from 'mobx'
import NotificationService from 'services/NotificationService'

const perPage = 10

export default class SignatureTemplatesListViewModel {
  private _signatureTemplates: SignatureTemplateModel[] = []
  private _pagination: Pagination | null = null
  private _searchQuery: string = ''
  private _debouncedSearchQuery: string = ''
  private _loading: boolean = false

  constructor() {
    makeAutoObservable(this)
    autoBind(this)

    reaction(
      () => [this._debouncedSearchQuery],
      () => {
        this.loadPage(1)
      },
    )
  }

  public async loadPage(page: number) {
    this._loading = true
    const response =
      await engine.signatureTemplatesEngine.getSignatureTemplates({
        page: page,
        per_page: perPage,
        search_term: this._debouncedSearchQuery,
      })
    if (response) {
      this._signatureTemplates = response.signatureTemplates
      this._pagination = response.pagination
    }
    this._loading = false
  }

  public get loading() {
    return this._loading
  }

  public async downloadHtml(signatureTemplate: SignatureTemplateModel) {
    const html = await signatureTemplate.fetchPreviewHtml()
    if (!html) {
      NotificationService.error('This template has no preview HTML')
      return
    }
    const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }))
    const link = document.createElement('a')
    link.href = url
    link.download = `${kebabCase(signatureTemplate.workspaceName)}-${kebabCase(signatureTemplate.name)}-${signatureTemplate.id}.html`
    link.click()
    URL.revokeObjectURL(url)
  }

  public setSearchQuery(query: string) {
    this._searchQuery = query
    this.debouncedSetSearchQuery()
  }

  private debouncedSetSearchQuery = debounce(() => {
    this._debouncedSearchQuery = this._searchQuery
  }, 500)

  public get searchQuery() {
    return this._searchQuery
  }

  public get signatureTemplates() {
    return this._signatureTemplates
  }

  public get pagination() {
    return this._pagination
  }
}
